export default {
    getters: {
        coordinates(state) {
            return state.coordinates
        }
    },
    state: {
        coordinates: []
    },
    mutations: {
        setCoordinates(state, coordinates) {
            state.coordinates = coordinates
        }
    },
    actions: {
        async createCoordinates({ dispatch, commit }, { software_codes }) {
            // console.log('Софты ' + software_codes)
            const response = await dispatch('apiRequest', {
                endpoint: 'coordinates',
                method: 'POST',
                data: {'codes': software_codes}
            })
            const coordinates = await response.json()
            // console.log(coordinates)
            commit('setCoordinates', coordinates)
        }
    }
}
